<ng-template #titleTmplRef>
    <pf-chip
        [class.task-list-item__chip--parts]="
            !priority && task.group === 'Parts'
        "
        [class.task-list-item__chip--uniforms]="
            !priority && task.group === 'Uniforms'
        "
        [icon]="task.taskIconType"
        [pfStatus]="priority ? 'danger' : 'primary'">
        {{ task.title }}
    </pf-chip>
</ng-template>
<pf-card [title]="titleTmplRef">
    <div class="task-list-item__content">
        <pf-text [type]="'description'">{{ task.details }}</pf-text>
        <div class="task-list-item__actions">
            <span class="task-list-item__actions-elapsed-time">{{
                task.time | PfDate: "elapsed"
            }}</span>
            <pf-button
                class="task-list-item__action-details"
                buttonType="icon"
                pfIcon="viewDetails"
                buttonSize="small"
                [pfDanger]="priority"
                [disabled]="readonly"></pf-button>
        </div>
    </div>
</pf-card>
